import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const ErrorModal = ({
  openErrorModal,
  handleCloseErrorModal,
  errorMessage,
  disablePortal = false,
  disableOkButtonRipple = false,
  disableOkButtonAutoFocus = false,
}) => {
  return (
    <Modal
      key="error-modal"
      open={openErrorModal}
      onClose={handleCloseErrorModal}
      disablePortal={disablePortal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Fade in={openErrorModal}>
        <Box
          sx={theme => ({
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #000",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
          })}
        >
          <h2>Internal Error</h2>
          <p>{errorMessage}</p>
          <Button
            sx={{ mt: 2 }}
            variant="contained"
            onClick={handleCloseErrorModal}
            autoFocus={!disableOkButtonAutoFocus}
            disableRipple={disableOkButtonRipple}
            disableFocusRipple={disableOkButtonRipple}
          >
            OK
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

ErrorModal.defaultProps = {
  errorMessage: "",
};

ErrorModal.propTypes = {
  openErrorModal: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  handleCloseErrorModal: PropTypes.func.isRequired,
  disablePortal: PropTypes.bool,
  disableOkButtonRipple: PropTypes.bool,
  disableOkButtonAutoFocus: PropTypes.bool,
};
export default ErrorModal;
